module.exports = __webpack_public_path__ + "img/face.e28bc8b7.svg";